var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout"},[_c('nav-bar'),_c('div',{staticClass:"layout-content"},[_c('sub-menu'),_c('div',{staticClass:"content",class:{ calcHeight: _vm.$route.meta.breadcrumb }},[_c('div',{ref:"router_view",staticClass:"router-view"},[_c('router-view',{attrs:{"containerScrollTop":_vm.scrollTop}})],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }